import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { SelectOption } from "src/app/shared/models/select-option.type";
import { NotificationService } from "src/app/core/services/notification.service";
import { OrdersService } from "../../feature/orders/services/orders.service";
import { Store } from "@ngxs/store";
import { LoadDispatchByDateStats } from "../../feature/dispatch-by-date/state/dispatch-by-date.actions";

@Component({
  selector: 'app-recall-dialog',
  templateUrl: './recall-dialog.component.html'
})
export class RecallDialogComponent implements OnInit {

	loading: boolean;
	recallForm: UntypedFormGroup;

	constructor(
		private store: Store,
		public fb: UntypedFormBuilder,
		private dialogRef: MatDialogRef<RecallDialogComponent>,
		private orderService: OrdersService,
		private notificationService: NotificationService,
		@Inject(MAT_DIALOG_DATA) public data: {
			id: string;
			name: string;
			unionId: number;
			unionOptions: SelectOption[];
		}
	) {}

	ngOnInit(): void {
		this.createForm();
	}

	private createForm(): void {
		this.recallForm = this.fb.group({
			unionId: [this.data.unionId || '', Validators.required],
			comments: ['', Validators.required]
		});
	}

	confirm(): void {
    this.loading = true;
		this.orderService.recallOrder(
			this.data.id,
			this.recallForm.get('unionId').value,
			this.recallForm.get('comments').value
		).toPromise().then(
			(response) => {
				this.notificationService.showSuccess("The labor order was recalled successfully.");
				this.dialogRef.close(response);
				this.store.dispatch(
					new LoadDispatchByDateStats()
				);
			},
			(error) => {
				this.notificationService.showError("There was a problem. Please try again.");
        this.loading = false;
			}
		)
	}

	close(): void {
		this.dialogRef.close();
	}

}
